import React, { Component } from "react";

import { Card, Button } from "react-bootstrap";

class ProjectCard extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    let { project } = this.props;
    return (
      <Card
        className="projectcard"
        data-aos="flip-left"
        data-aos-anchor=".skills-section"
        data-aos-anchor-placement="bottom-center"
      >
        <Card.Img variant="top" src={project.img} className="projectimg" />
        <Card.Body>
          <Card.Title>{project.name}</Card.Title>
          <Card.Text>{project.content}</Card.Text>
          <Button
            variant="primary"
            href={project.link}
            target="_blank"
            className="gitbtn"
          >
            GitHub Link
          </Button>
        </Card.Body>
      </Card>
    );
  }
}

export default ProjectCard;
